import { animate } from 'motion';

const elements = document.querySelectorAll('.animated-txt');

elements.forEach(container => {
  const animTxts = container.querySelectorAll('.anim-txt');

  animTxts.forEach(node => {
    const innerSpans = node.querySelectorAll('span');

    innerSpans.forEach(span => {
      const text = span.textContent.trim();
      const words = text.split(/\s+/);

      const fragment = document.createDocumentFragment();

      words.forEach((word, i) => {
        const w = document.createElement('span');
        w.textContent = word;
        w.className = span.className || '';
        fragment.appendChild(w);

        if (i < words.length - 1) {
          fragment.appendChild(document.createTextNode(' '));
        }
      });

      span.replaceWith(fragment);
    });
  });

  animTxts.forEach(node => {
    Array.from(node.childNodes).forEach(child => {
      if (child.nodeType === 3) {
        const text = child.textContent;
        const words = text.split(/(\s+)/);
        const fragment = document.createDocumentFragment();

        words.forEach(part => {
          if (/\s+/.test(part)) {
            fragment.appendChild(document.createTextNode(part));
          } else {
            const span = document.createElement('span');
            span.className = 'word';
            span.textContent = part;
            fragment.appendChild(span);
          }
        });

        child.replaceWith(fragment);
      }
    });

    node.style.opacity = 1;
  });

  animTxts.forEach(node => {
    const innerSpans = node.querySelectorAll('span');

    innerSpans.forEach(span => {
      if (!span.textContent.trim()) {
        span.remove();
      }
    });
  });

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animTxts.forEach(txt => {
            const span = txt.querySelectorAll('span');

            animate(
              span,
              {
                opacity: [0, 1],
                transform: ['translateY(25%)', 'translateY(0)'],
              },
              {
                duration: 0.6,
                delay: i => i * 0.1,
                easing: 'ease-out',
              }
            );
          });

          observer.unobserve(container);
        }
      });
    },
    { threshold: 0.3 }
  );

  observer.observe(container);
});
